import { useNavigate } from 'react-router'

const NotFoundMedia: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div className="bgd-theme flex h-dvh w-dvw items-center justify-center">
      <div className="text-2xl">
        Resource not found, please go back to{' '}
        <button
          type="button"
          className="text-blue cursor-pointer underline"
          onClick={() => {
            navigate('/home', { replace: true })
          }}
        >
          home
        </button>
      </div>
    </div>
  )
}

export default NotFoundMedia
